import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Device } from '../../interfaces/api/device';
import { fetchDevices } from '../services/devices.service';
import { DeviceFilterParams } from '../../api/devices';

interface DeviceState {
	devices: {
		byId: Record<number, Device>;
		all: Device[];
	};
	selectedDevice: Device | undefined;
	isLoading: boolean;
}

const initialState = {
	devices: {
		byId: {},
		all: [],
	},
	selectedDevice: undefined,
	isLoading: false,
} as DeviceState;

export const fetchDevicesThunk = createAsyncThunk<Device[], { params: DeviceFilterParams }>(
	'device/fetchDevices',
	async ({ params }, { rejectWithValue }) => {
		try {
			return await fetchDevices(params);
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

const deviceSlice = createSlice({
	name: 'device',
	initialState,
	reducers: {
		selectDevice: (state, action: PayloadAction<number>) => {
			state.selectedDevice = state.devices.byId[action.payload];
			localStorage.setItem('selectedDevice', String(state.devices.byId[action.payload].id));
		},
		unSelectDevice: (state) => {
			state.selectedDevice = undefined;
			localStorage.removeItem('selectedDevice');
		},
		resetDevice: (state) => {
			Object.assign(state, initialState);
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchDevicesThunk.fulfilled, (state, action) => {
			const byId: Record<number, Device> = {};
			action.payload.forEach((device) => {
				byId[device.id] = device;
			});
			const all = action.payload.map((device) => device);
			state.devices = { byId, all };
			const selectedStorageId = localStorage.getItem('selectedDevice');
			if (selectedStorageId && byId[Number(selectedStorageId)]) {
				state.selectedDevice = byId[Number(selectedStorageId)];
			} else {
				if (action.payload.length > 0) {
					localStorage.setItem('selectedDevice', String(action.payload[0].id));
					state.selectedDevice = action.payload[0];
				}
			}
			state.isLoading = false;
		});
		builder.addCase(fetchDevicesThunk.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchDevicesThunk.rejected, (state, action) => {
			state.devices = {
				byId: {},
				all: [],
			};
			state.isLoading = false;
		});
	},
});

export const { selectDevice, unSelectDevice, resetDevice } = deviceSlice.actions;

export default deviceSlice;
